<template>
    <div class="announcement" :class="announcement.importance">
        <div class="container">
            <div class="icon-wrapper">
                <svg v-if="announcement.importance === 'notice'" viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.99998 1.00626C4.3031 1.00626 0.506226 4.80313 0.506226 9.50001C0.506226 14.1969 4.3031 18.0219 8.99998 18.0219C13.6969 18.0219 17.5219 14.1969 17.5219 9.50001C17.5219 4.80313 13.6969 1.00626 8.99998 1.00626ZM8.99998 16.7563C5.00623 16.7563 1.77185 13.4938 1.77185 9.50001C1.77185 5.50626 5.00623 2.27188 8.99998 2.27188C12.9937 2.27188 16.2562 5.53438 16.2562 9.52813C16.2562 13.4938 12.9937 16.7563 8.99998 16.7563Z"/>
                    <path d="M10.125 8.14999H7.87496C7.53746 8.14999 7.22809 8.43124 7.22809 8.79687V14.4219C7.22809 14.7594 7.50934 15.0687 7.87496 15.0687H10.125C10.4625 15.0687 10.7718 14.7875 10.7718 14.4219V8.79687C10.7718 8.43124 10.4625 8.14999 10.125 8.14999ZM9.50621 13.775H8.52184V9.41562H9.50621V13.775Z"/>
                    <path d="M8.99996 3.95938C8.04371 3.95938 7.22809 4.74688 7.22809 5.73126C7.22809 6.71563 8.01559 7.50313 8.99996 7.50313C9.98434 7.50313 10.7718 6.71563 10.7718 5.73126C10.7718 4.74688 9.95621 3.95938 8.99996 3.95938ZM8.99996 6.20938C8.71871 6.20938 8.49371 5.98438 8.49371 5.70313C8.49371 5.42188 8.71871 5.19688 8.99996 5.19688C9.28121 5.19688 9.50621 5.42188 9.50621 5.70313C9.50621 5.98438 9.28121 6.20938 8.99996 6.20938Z"/>
                </svg>
                <svg v-if="announcement.importance === 'attention'"  viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.0156 12.1156L10.9969 2.43125C10.5188 1.78437 9.78752 1.41875 9.00002 1.41875C8.18439 1.41875 7.45314 1.78437 7.00314 2.43125L0.984395 12.1156C0.421895 12.875 0.33752 13.8594 0.759395 14.7031C1.18127 15.5469 2.02502 16.0812 2.98127 16.0812H15.0188C15.975 16.0812 16.8188 15.5469 17.2406 14.7031C17.6625 13.8875 17.5781 12.875 17.0156 12.1156ZM16.1156 14.1406C15.8906 14.5625 15.4969 14.8156 15.0188 14.8156H2.98127C2.50315 14.8156 2.10939 14.5625 1.88439 14.1406C1.68752 13.7187 1.71564 13.2406 1.99689 12.875L8.01564 3.19062C8.24064 2.88125 8.60627 2.68437 9.00002 2.68437C9.39377 2.68437 9.75939 2.85312 9.9844 3.19062L16.0031 12.875C16.2844 13.2406 16.3125 13.7187 16.1156 14.1406Z" />
                    <path d="M8.99996 6.65002C8.66246 6.65002 8.35309 6.93127 8.35309 7.29689V10.3625C8.35309 10.7 8.63434 11.0094 8.99996 11.0094C9.36559 11.0094 9.64684 10.7281 9.64684 10.3625V7.26877C9.64684 6.93127 9.33746 6.65002 8.99996 6.65002Z" />
                    <path d="M8.99996 11.75C8.66246 11.75 8.35309 12.0313 8.35309 12.3969V12.5375C8.35309 12.875 8.63434 13.1844 8.99996 13.1844C9.36559 13.1844 9.64684 12.9031 9.64684 12.5375V12.3688C9.64684 12.0313 9.33746 11.75 8.99996 11.75Z" />
                </svg>
                <svg v-if="announcement.importance === 'urgent'"  viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.99998 0.0062561C4.3031 0.0062561 0.506226 3.80313 0.506226 8.50001C0.506226 13.1969 4.3031 17.0219 8.99998 17.0219C13.6969 17.0219 17.5219 13.1969 17.5219 8.50001C17.5219 3.80313 13.6969 0.0062561 8.99998 0.0062561ZM8.99998 15.7563C5.00623 15.7563 1.77185 12.4938 1.77185 8.50001C1.77185 4.50626 5.00623 1.27188 8.99998 1.27188C12.9937 1.27188 16.2562 4.53438 16.2562 8.52813C16.2562 12.4938 12.9937 15.7563 8.99998 15.7563Z" />
                    <path d="M11.5875 5.88439C11.3344 5.63127 10.9406 5.63127 10.6875 5.88439L8.99999 7.60002L7.28436 5.88439C7.03124 5.63127 6.63749 5.63127 6.38436 5.88439C6.13124 6.13752 6.13124 6.53127 6.38436 6.78439L8.09999 8.50002L6.38436 10.2156C6.13124 10.4688 6.13124 10.8625 6.38436 11.1156C6.49686 11.2281 6.66561 11.3125 6.83436 11.3125C7.00311 11.3125 7.17186 11.2563 7.28436 11.1156L8.99999 9.40002L10.7156 11.1156C10.8281 11.2281 10.9969 11.3125 11.1656 11.3125C11.3344 11.3125 11.5031 11.2563 11.6156 11.1156C11.8687 10.8625 11.8687 10.4688 11.6156 10.2156L9.89999 8.50002L11.6156 6.78439C11.8406 6.53127 11.8406 6.13752 11.5875 5.88439Z" />
                </svg>
            </div>

            <div class="content">
                <span class="title" @click="viewAnnouncement">{{ announcement.post_title }}</span>
                <span v-if="announcement.excerpt" class="excerpt">{{ announcement.excerpt }}</span>
                <span class="read-more"  @click="viewAnnouncement" tabindex="0">[read more]</span>
            </div>

            <span v-if="!announcement.is_permanent" type="button" class="dismiss-btn" tabindex="0" @click="closeAnnouncement" aria-label="Dismiss Announcement"></span>
        </div>

    </div>
</template>

<script>
import themConfig from './../../../config.json';

export default {
    data() {
        return {
            themeData: window[themConfig.theme_prefix + 'data']
        };
    },

    props: {
        announcement: {
            type:    Object,
            default: {}
        },
        index:        {
            type:    Number,
            default: 0
        },
        setInactiveAfterViewing: {
            type:    Boolean,
            default: true
        }
    },


    mounted() {
        // console.log(this.announcement);
        // console.log("Announcement.vue");
        // console.log(this.setInactiveAfterViewing);
    },

    methods: {
        setAnnouncementCookieToInactive() {
            let cookieString =  this.announcement.post_type + '_' + this.announcement.ID;
            const date = new Date();
            date.setTime(date.getTime() + (365*10*24*60*60*1000));
            let expires = "expires="+ date.toUTCString();
            document.cookie = cookieString + "=" + 'inactive' + ";" + expires + ";path=/";
        },
        deleteAnnouncement() {
            this.$parent.items.splice(this.index, 1);
        },
        closeAnnouncement() {

            this.setAnnouncementCookieToInactive();
            this.deleteAnnouncement();

            setTimeout(() => {
                this.$parent.stylePageBanner();
            }, "10");
        },
        viewAnnouncement() {
            if(this.setInactiveAfterViewing && !this.announcement.is_permanent) {
                this.setAnnouncementCookieToInactive();
            }
            window.location.href = this.announcement.permalink;
        }
    },

}
</script>
